<template>
  <div class="conteudoInterno" id="diretor-executivo">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" :class="{
        setaScroll: setaScrollState,
      }">
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>A Few Words from our CEO</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcBlueBack"></span>
        </div>
      </section>
      <section class="sectionRow top65">
        <div class="col49">
          <img title="Marcelo Castelo Branco" alt="Marcelo Castelo Branco"
            src="../assets/imgs/marcelo_castelo_branco.jpg" />

          <h4 class="h4Destaque">
            “Our goal is to ensure that <span class="ubcBlue sanukBlack">AI</span> respects creators’ rights and provides fair remuneration to those whose work makes it possible — a principle that remains our highest priority and guiding commitment.
            ”
          </h4>
        </div>
        <div class="col40ponto4">
          <p>A record-breaking distribution of BRL 1 billion. This is the first time a Brazilian collective management
            organization has surpassed this milestone, fulfilling its mission and its unwavering commitment to
            remunerating our nearly 71,000 direct members and more than 200,000 rightsholders worldwide.</p>

          <p>This record distribution reflects the care we devote to our day-to-day operations, our continuous and
            increasingly significant investment in technology and innovation, and our commitment to remaining a
            progressive, inclusive and diverse collective management organization whose identity has been shaped over
            nearly 85 years by a clear focus on both present realities and future challenges.</p>

          <p>In 2025, we launched new versions of our website and member portal, featuring more modern applications and
            services. The centerpiece is our chatbot, affectionately named Chiquinha in tribute to the musician
            Chiquinha Gonzaga. As a <span class="ubcBlue sanukBlack">mixed-race woman</span>, she overcame the prejudices of a patriarchal and slave-owning
            society to establish herself as a pianist, composer and conductor, ultimately becoming a leading advocate
            for creators’ rights.</p>

          <p>Throughout the year, UBC continued its tradition of honoring outstanding figures in Brazilian music during
            their lifetimes. Through the UBC Medal, we celebrated the work of Luiz Caldas, marking the 40th anniversary
            of axé music genre. With the Traditions Trophy, we paid tribute to Rosa Passos, whose musical excellence is
            celebrated around the world yet remains undeservedly underrecognized in Brazil. And at the ninth edition of
            the UBC Award, we honored the work of Zeca Pagodinho, a samba icon cherished across Brazil.</p>

          <p>Throughout the year, we hosted educational and networking events at the new UBC House —reopened in March
            during a CISAC Board of Directors meeting in Rio de Janeiro— as well as in São Paulo and in the many other
            Brazilian cities where we maintain member services and creative relations offices. In recognition of the
            state of Ceará’s vibrant music market, we also opened a new office in its capital city, Fortaleza.</p>

          <p>On the public policy front, we remained highly engaged in Brasilia. Together with many of our members and
            UBC’s leadership team, we continued advocating for an ethical and responsible regulatory framework for
            Artificial Intelligence in Brazil and around the world. Our goal is to ensure that this technology respects
            creators’ rights and provides fair remuneration to those whose work makes it possible —a principle that
            remains our highest priority and guiding commitment.</p>

          <p>In 2026, UBC was once again elected to the CISAC Board of Directors. I also concluded, in accordance with
            the organization’s bylaws, my six-year term as President of this vital institution, which brings together
            more than 226 collective management organizations and approximately five million creators worldwide. I am
            proud of this distinction and of having been the only Latin American ever to hold this position in CISAC’s
            now 100-year history.</p>

          <p>All of this reflects the leadership role and professionalism with which UBC carries out the mandate
            entrusted to us by those who place their works and catalogues in our care. It is the result of a united and
            tireless team committed to pursuing best practices and innovative strategies, supported by an active Board
            that contributes to management in an objective and constructive manner.</p>

          <p>And we want to achieve even more. More for our members, and more for the talent, artistry and diversity of
            the creators we are proud to represent.</p>

          <br />
          <p class="sanukBold ubcBlue">Marcelo Castello Branco</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";

export default {
  name: "FewWordFromOurCEO",
  props: ["clicked"],
  data() {
    return {
      setaScrollState: false,
    };
  },
  mounted() {
    const conteudo = document.querySelector("#diretor-executivo");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col49 img {
  width: 100%;
  max-width: 586px;
}

.h4Destaque {
  max-width: 586px;
  margin-top: 140px;
}

@media screen and (max-width: 800px) {
  .h4Destaque {
    max-width: unset;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
</style>
